import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

export function drawPhase(draw, now) {
  if (!draw) return 0;
  return Math.max(0, Math.min(1, (now - Date.parse(draw.started_at)) / (Date.parse(draw.ends_at) - Date.parse(draw.started_at))));
}

export default function DrawPanel() {
  const [draw, setDraw] = useState(null);
  const [offset, setOffset] = useState(0);
  const [now, setNow] = useState(Date.now());
  const [offline, setOffline] = useState(false);
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get("/draws/current", { timeout: 5000 });
        if (!active) return;
        setDraw(data); setOffline(false);
        if (data?.server_now) setOffset(Date.parse(data.server_now) - Date.now());
      } catch { if (active) setOffline(true); }
    };
    load();
    const poll = setInterval(load, 2000);
    const tick = setInterval(() => setNow(Date.now()), 100);
    return () => { active = false; clearInterval(poll); clearInterval(tick); };
  }, []);
  const progress = drawPhase(draw, now + offset);
  const names = draw?.preview || [];
  const frame = Math.floor(progress * 150);
  return <section data-testid="public-draw" className="rounded-3xl border border-gold-500/25 bg-gradient-to-br from-gold-500/10 via-[#111113] to-black p-6 md:p-8 overflow-hidden">
    <div className="flex justify-between items-center gap-4 flex-wrap"><h2 className="font-display text-2xl font-black text-gold-400">سحوبات RIVALS</h2>
      {draw && <span className="text-xs text-white/60">{draw.participant_count} حساب مؤهل • فرصة واحدة لكل حساب</span>}</div>
    {!draw ? <p className="text-white/50 py-8 text-center">ترقّب السحب القادم من إدارة Rivals</p> : draw.winner ?
      <div className="py-8 text-center space-y-3" aria-live="polite">
        <p className="text-gold-300 font-bold">الفائز بالسحب 🏆</p>
        {draw.winner.avatar && <img src={draw.winner.avatar} alt="" className="w-20 h-20 rounded-full object-cover mx-auto border-2 border-gold-400" />}
        <Link className="font-black text-3xl text-white" to={`/players/${draw.winner.id}`}>{draw.winner.username}</Link>
      </div> : <div className="py-6 text-center space-y-4">
        <p className="text-gold-300 font-bold">{progress < 1 ? "السحب جارٍ الآن…" : "بانتظار النتيجة المعتمدة…"}</p>
        <div className="grid grid-cols-3 gap-3 max-w-2xl mx-auto" aria-hidden="true">
          {[0, 1, 2].map(i => <div key={i} className={`rounded-xl py-7 px-2 truncate text-lg font-black border transition-all ${i === 1 ? "bg-gold-500/20 border-gold-400 text-gold-200 scale-105" : "bg-black/40 border-white/10 text-white/40"}`}>{names.length ? names[(frame+i)%names.length].username : "RIVALS"}</div>)}
        </div>
        <div className="h-1.5 bg-white/10 rounded-full overflow-hidden"><div className="h-full bg-gold-500 transition-all duration-100" style={{ width: `${progress*100}%` }} /></div>
        <p className="text-xs text-white/50">جميع الحسابات المؤهلة مشمولة. النتيجة واحدة ومعتمدة لجميع الزوار.</p>
      </div>}
    {offline && <p className="text-xs text-amber-300">الاتصال متقطع؛ سيتم جلب النتيجة المعتمدة عند عودته.</p>}
    {draw && <details className="text-[10px] text-white/40"><summary className="cursor-pointer">بيانات تدقيق السحب</summary>
      <p className="mt-2 break-all" dir="ltr">ID: {draw.id}<br />Participants SHA-256: {draw.participants_hash}<br />Winner commitment: {draw.winner_commitment}</p>
      {draw.winner_nonce && <p dir="ltr" className="break-all">Revealed nonce: {draw.winner_nonce}</p>}
    </details>}
  </section>;
}
